<template>
  <div class="login">
    <div class="forgot-wrap">
      <div class="login-icon"><i></i></div>
      <h2>忘记密码</h2>
      <div v-if="step==1" class="forgot-form">
        <Form :label-width="0" ref="forgotForm" :model="formValidate" :rules="ruleValidate">
            <p class="title">手机号或邮箱</p>
            <FormItem prop="loginName">
                  <Input @on-enter="nextStep" @on-blur="isPhone" size="large" v-model="formValidate.loginName"></Input>
            </FormItem>
            <p class="title">验证码</p>
            <FormItem prop="obj" style="position: relative;">
                <!-- <Input size="large" @on-enter="nextStep" v-model="formValidate.veriImage" :maxlength="8">
                </Input>
                <div class="form-verify-img"><img :src="vImg" @click="setVerifyImg" /></div> -->
                <ali-yun-check @getCheck="getCheck"></ali-yun-check>
            </FormItem>
            <p v-if="isShowPhone" class="title">手机验证码</p>
            <FormItem prop="verifyCode" v-if="isShowPhone" style="position: relative;">
                <Input size="large" @on-enter="nextStep" v-model="formValidate.verifyCode" :maxlength="8">
                </Input>
                <div class="phone-img-wrap">
                  <a v-if="!sending" href="javascript:;" @click="sendCode">发送验证码</a>
                  <a v-else class="unsend" href="javascript:;">重新发送 {{seconds}}</a>
                </div>
            </FormItem>
        </Form>
        <Button type="primary" style="width:350px;margin-top:10px;font-size:16px;"  :loading="!!submitting" @click="nextStep" size="large">下一步</Button>
      </div>
      <div v-if="step==2" class="forgot-message">
        <p>我们已经发送了一封验证邮件</p>
        <p>至您的邮箱&nbsp;<a :href="'mailto:'+formValidate.loginName">{{formValidate.loginName}}</a></p>
        <p>请在24小时内完成验证</p>
      </div>
      <div v-if="step==3" class="forgot-form">
        <Form :label-width="0" ref="forgotForm2" :model="formValidate2" :rules="ruleValidate2">
            <p class="title">新密码</p>
            <FormItem prop="newPassword">
              <Input @on-enter="submit" size="large" type="password" v-model="formValidate2.newPassword" :maxlength="20" :minlength="6"></Input>
            </FormItem>
            <p class="title">确认新密码</p>
            <FormItem prop="reNewPassword">
              <Input @on-enter="submit" size="large" type="password" v-model="formValidate2.reNewPassword" :maxlength="20" :minlength="6"></Input>
            </FormItem>
        </Form>
        <Button type="primary" style="width:350px;margin-top:10px;font-size:16px;" :loading="!!submitting" @click="submit" size="large">确定</Button>
      </div>
    </div>
    <p class="p-bottom" v-if="step==1">
      <a class="fl" href="#/?type=register">没有账号？立即注册</a>
      <a class="fr" href="#/?type=login">已有账号？立即登录</a>
    </p>
  </div>
</template>

<script>

import DB from '@/common/db'
import MD5 from '@/common/md5'


export default {
  name: 'forgot',
  data () {
    const validateImg = (rule ,value , cb) =>{
        if(!value && this.isShowPhone){
          cb(new Error('请填写手机验证码'));
        }else{
          cb();
        }
    };
    const validateLoginName =( rule ,value , cb) =>{
        if(!value){
          return cb(new Error('请填写手机号或邮箱'));
        }
        if(!this.emailReg.test(value) && !this.phoneReg.test(value)){
          return cb(new Error('请填写正确的格式'));
        }
        return cb();
    };
    const validatePass = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请填写新密码'));
        } else if(!/^[^\s]*$/.test(value)){
            callback(new Error('密码不允许含空格'));
        } else if(value.length < 6){
            callback(new Error('密码不能少于6位'));
        } else{
            if (this.formValidate2.reNewPassword !== '') {
                // 对第二个密码框单独验证
                this.$refs.forgotForm2.validateField('reNewPassword');
            }
            callback();
        }
    };
    const validatePassCheck = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请填写确认密码'));
        } else if(!/^[^\s]*$/.test(value)){
            callback(new Error('密码不允许含空格'));
        } else if(value.length < 6){
            callback(new Error('密码不能少于6位'));
        } else if (value !== this.formValidate2.newPassword) {
            callback(new Error('两次密码输入不一致'));
        } else {
            callback();
        }
    };
    return {
      authCode: this.$route.query.vd ? this.$route.query.vd : '',
      vImg:null,
      sending: false,
      seconds: 0,
      isShowPhone: false,
      phoneReg:  /^1[0-9]{10}$/,
      emailReg: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
      step: this.$route.query.step ? this.$route.query.step : 1,
      formValidate:{
        loginName: null,
        veriImage: null,
        verifyCode: null,
        obj: null
      },
      formValidate2:{
          newPassword: '',
          reNewPassword: ''
      },
      ruleValidate:{
        loginName:[
          {validator: validateLoginName, trigger: 'blur'}
        ],
        // veriImage:{type:'string', required: true, message: '请填写图片验证码', trigger: 'blur' },
        obj:{required: true, message: '请滑动验证码'},
        verifyCode:{ validator: validateImg, trigger: 'blur' }
      },
      ruleValidate2:{
        newPassword:[
            {validator: validatePass, trigger: 'blur' }
        ],
        reNewPassword:[
            {validator: validatePassCheck, trigger: 'blur' }
        ]
      },
      submitting: null
    }
  },
  methods:{
    getCheck(data){
      this.formValidate.obj = data && Object.keys(data).length ? {...data} : null;
      if(this.formValidate.obj){
        this.$refs.forgotForm.validateField("obj");
      }
    },
    setVerifyImg(){
      // this.vImg = DB.prefix + 'common/v2/imageVerCode?st='+ new Date().getTime();
      if(window.nc){
        window.nc.reset();
      }
    },
    isPhone(){
      if (this.emailReg.test(this.formValidate.loginName)) {
          this.isShowPhone = false;
      } else {
          this.isShowPhone = true;
      }
    },
    sendCode(){
      if(this.seconds > 0){
          return;
      }
      if(!this.formValidate.loginName || !this.phoneReg.test(this.formValidate.loginName)) {
        this.$refs.forgotForm.validateField('loginName');
        return;
      }
      if(!this.formValidate.obj || !Object.keys(this.formValidate.obj).length) {
        this.$refs.forgotForm.validateField('obj');
        return;
      }
      this.seconds = 60;
       DB.request({
          url: DB.prefix + 'auth/v2/forgetPwdPhoneCode',
          data: {
              mobilePhone: this.formValidate.loginName,
              // imageVeriCode: this.formValidate.veriImage
              ...this.formValidate.obj
          },
          success:(res)=>{
            this.sending = true;
            let intervalTimer = setInterval(()=>{
                this.seconds--;
                if(this.seconds < 1){
                    this.sending = false;
                    clearInterval(intervalTimer);
                }
            },1000);
          },
          error:()=>{
            this.seconds = 0;
            this.setVerifyImg();
          },
          complete:()=>{
          }
      });
    },
    nextStep(){
      if (!this.isShowPhone){
        this.$refs['forgotForm'].validate((valid) => {
          if (valid) {
            this.submitting = true;
            DB.request({
                url: DB.prefix + 'auth/v2/preforgetpassByEmail',
                type:'post',
                data: {
                  loginName: this.formValidate.loginName,
                  // veriImage: this.formValidate.veriImage
                  ...this.formValidate.obj
                },
                showMessage: false,
                success:(data)=>{
                  this.step = 2;
                },
                complete:()=>{
                  this.submitting = false;
                }
            });
          }
        });
      } else {
        this.$refs['forgotForm'].validate((valid) => {
          if (valid) {
            this.submitting = true;
            DB.request({
                url: DB.prefix + 'auth/v2/preforgetpassByMobile',
                type:'post',
                data: {
                  mobilePhone: this.formValidate.loginName,
                  verifyCode: this.formValidate.verifyCode
                },
                showMessage: false,
                success:(data)=>{
                  this.authCode = data.data && data.data.authCode ? data.data.authCode : '';
                  this.step = 3;
                },
                complete:()=>{
                  this.submitting = false;
                }
            });
          }
        });
      }
    },
    submit(){
      this.$refs['forgotForm2'].validate((valid) => {
        if (valid) {
          this.submitting = true;
          DB.request({
              url: DB.prefix + 'auth/v2/resetPass',
              type:'post',
              data: {
                newPassword: MD5(this.formValidate2.newPassword),
                reNewPassword: MD5(this.formValidate2.reNewPassword),
                authCode: this.authCode
              },
              successText: '密码重置成功',
              success:(data)=>{
                this.$router.push({path: '/'});
              },
              complete:()=>{
                this.submitting = false;
              }
          });
        }
      });
    }
  },
  created(){
    // this.setVerifyImg();
  },
  components: {
    'aliYunCheck': resolve => require(['@/components/aliYunCheck'], resolve)
  },
  mounted(){
  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  
</style>
<style lang="scss" scoped>
  .p-bottom{
    margin: 10px auto 30px;
    width: 400px;
    a{
      font-size: 14px;
      color: #6C757D;
      &:hover{
        color: #2d8cf0;
      }
    }
  }
  .forgot-wrap {
    width:400px;
    background:#fff;
    margin: 150px auto 0;
    border: 1px solid #E6EAEE;
    position: relative;
    .login-icon{
      width: 70px;
      height: 70px;
      position: absolute;
      top: -35px;
      left: 165px;
      background: #2d8cf0;
      border-radius: 50%;
      i{
        width: 70px;
        height: 70px;
        display: block;
        background: url('../../assets/logo.png') no-repeat center center;
      }
    }
    .title{
      font-size: 14px;
      color: #6C757D;
      letter-spacing: 0;
      line-height: 20px;
      margin-bottom: 5px;
    }
    .forgot-message {
      width:350px;
      margin:80px auto 80px;
      p{
        text-align: center;
        margin-bottom: 10px;
        font-size: 14px;
        color: #393A41;
      }
    }
    .forgot-form {
      width:350px;
      margin:30px auto;
    }
    h2 {
      padding: 50px 0 20px;
      text-align:center;
      font-size:24px;
      color:#393A41;
      border-bottom: 1px solid #E6EAEE;
      background: #FAFBFC;
    }
    .form-verify-img {
      display:inline-block;
      height:25px;
      overflow: hidden;
      position: absolute;
      right: 10px;
      top: 6px;
      img {
        height:25px;
        display:inline-block;
      }
    }
    .phone-img-wrap{
      position: absolute;
      right: 10px;
      top: 0;
      a{
        line-height: 35px;
        color: #2d8cf0;
        display: inline-block;
        height: 35px;
      }
      .unsend{
        cursor: not-allowed;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/forgot/index.vue